/* eslint-disable */
import TurnoService from "@/services/TurnoService"

export default {
  namespaced: true,
  state: {
    listaTurnos: [],
    listaMisTurnos: [],
    listaMedicos: [],
    listaFechas: [],
    fechaFilters: [],
    medicoFilters: [],
    connected: false,
    terminarOperacion: null,
    error: null
  },
  getters: {
    getTurnosByMedico: (state) => (idMedico) => {
      return state.listaTurnos.filter(turno => turno.idMedico === idMedico)
    },
    getTurnosFiltrados: (state) => {
      let resultado = []
      if (state.medicoFilters.length === 0 && state.fechaFilters.length === 0) {
        resultado = state.listaTurnos
      }

      if (state.medicoFilters.length !== 0) {
        resultado = state.listaTurnos.filter(turno => {
          let test = state.medicoFilters.filter(filtro => filtro === turno.idMedico)
          return test.length !== 0
        })
      }

      if (state.fechaFilters.length !== 0) {
        if (state.medicoFilters.length === 0) {
          resultado = state.listaTurnos
        }
        resultado = resultado.filter(turno => {
          let test = state.fechaFilters.filter(filtro => filtro === turno.fecha.substring(0, 10))
          return test.length !== 0
        })
      }
      let turnosAgrupados = []
      let listaIdMedicos = [...new Set(resultado.map(turno => turno.idMedico))]
      for (let index = 0; index < listaIdMedicos.length; index++) {
        const element = listaIdMedicos[index]
        let turnos = resultado.filter(turno => turno.idMedico === element)
        let medico = {
          'idMedico': turnos[0].idMedico,
          'medico': turnos[0].medico,
          'especialidad': turnos[0].especialidad,
        }
        let fechas = [...new Set(turnos.map(turno => turno.fechaFormated))]
        let turnosGrupadosPorFecha = []
        for (let index = 0; index < fechas.length; index++) {
          const element = fechas[index];
          let convertDate = element.split('/').reverse().join('-')
          let dayTemp = new Date(convertDate + 'T00:00:00')
          let isoFormat = new Intl.DateTimeFormat('es-PY', { weekday: 'long' }).format(dayTemp)
          let turnosPorFecha = {
            'fecha': element,
            'weekday': isoFormat,
            'turnos': turnos.filter(turno => turno.fechaFormated === element),
          }
          turnosGrupadosPorFecha.push(turnosPorFecha)
        }
        let medicoObject = {
          'medico': medico,
          'turnos': turnosGrupadosPorFecha
        }
        turnosAgrupados.push(medicoObject)
      }
      return turnosAgrupados
    }
  },
  mutations: {
    setListaTurnos(state, data) {
      state.listaTurnos = []
      state.listaMedicos = []
      state.listaFechas = []

      let listaAllTurnos = data.turnos
      let listaPacientes = data.pacientes
      for (let turnoIndex = 0; turnoIndex < listaAllTurnos.length; turnoIndex++) {
        let turno = listaAllTurnos[turnoIndex];
        let fechaTemp = turno.fecha.split('T')[0]
        let fechaTempIso = new Date(fechaTemp)
        turno.fechaDayFormated = new Intl.DateTimeFormat('es-PY', { weekday: 'long' }).format(fechaTempIso)
        turno.fechaFormated = fechaTemp.split('-').reverse().join('/')
        turno.hora = turno.hora.substring(0, 5)

        if (turno.filtroSexo === null && turno.filtroFechaNacimientoDesde === null && turno.filtroFechaNacimientoHasta === null) {
          state.listaTurnos.push(turno)
        } else {
          for (let pacienteIndex = 0; pacienteIndex < listaPacientes.length; pacienteIndex++) {
            const paciente = listaPacientes[pacienteIndex];
            if (TurnoService.matchTurnoPaciente(turno, paciente)) {
              state.listaTurnos.push(turno)
              break;
            }
          }
        }
      }
      let listaIdMedicos = [...new Set(state.listaTurnos.map(turno => turno.idMedico))]
      state.listaMedicos = listaIdMedicos.map(id => {
        let medico = state.listaTurnos.find(turno => turno.idMedico === id)
        return {
          idMedico: medico.idMedico,
          medico: medico.medico,
          especialidad: medico.especialidad,
        }
      })
      state.listaFechas = [...new Set(state.listaTurnos.map(turno => turno.fecha.split('T')[0]))]
      state.listaFechas.sort(function(a,b){
        return new Date(a).getTime() - new Date(b).getTime()
      })
    },

    setMedicoFilters(state, filters) {
      state.medicoFilters = filters
    },

    setFechaFilters(state, filters) {
      state.fechaFilters = filters
    },

    getLista(state, message) { },

    SET_CONNECTION(state, message) {
      state.connected = message;
    },

    STOP_CONNECTION() { },

    SET_ERROR(state, error) {
      state.error = error;
    },

    setOperacionFlag(state, flag) {
      state.terminarOperacion = flag
    },

    // This mutation doesnt change the state. It is called so the websocket plugin can listen on the call and make a reservation
    reservarTurno(state, turno) { },

    // This mutation doesnt change the state. It is called so the websocket plugin can listen on the call and cancel a reservation
    anularTurno(state, turno) { },

    setMisTurnos(state, listaTurnos) {
      state.listaMisTurnos = listaTurnos.map(turno => {
        turno.turnoMedico.fechaFormated = turno.turnoMedico.fecha.split('T')[0].split('-').reverse().join('/')
        turno.turnoMedico.horaFormated = turno.turnoMedico.hora.substring(0, 5)
        let words = turno.paciente.nombre.split(' ')
        let abr = ''
        if (words.length <= 3 && words.length >= 2) {
          abr = `${words[0][0]}${words[1][0]}`
        } else {
          abr = `${words[0][0]}${words[2][0]}`
        }
        turno.event = {
          name: abr,
          start: new Date(`${turno.turnoMedico.fecha.split('T')[0]}T${turno.turnoMedico.hora}`),
          end: new Date(`${turno.turnoMedico.fecha.split('T')[0]}T23:59:59`),
          color: 'green',
          timed: true,
          medico: turno.turnoMedico.medico,
          horaFormated: turno.turnoMedico.horaFormated,
          fechaFormated: turno.turnoMedico.fechaFormated,
          paciente: turno.paciente.nombre,
          celular: turno.numeroNotificacion,
          idPaciente: turno.idPaciente,
          origenReserva: turno.turnoMedico.origenReserva,
          idTurnoMedico: turno.turnoMedico.idTurnoMedico
        }
        return turno
      }).sort(function (a, b) {
        let c = new Date(a.turnoMedico.fecha)
        let d = new Date(b.turnoMedico.fecha)
        return c - d
      })
    },
    clearMisTurnos(state) {
      state.listaMisTurnos = []
    }

  },
  actions: {
    async setTurnos({ commit, rootState }, turnos) {
      let pacientes = rootState.parametro.listaPacientes
      commit('setListaTurnos', { turnos: turnos, pacientes: pacientes })
    },
    getListaTurnos({ commit }, message) {
      commit('getLista', message)
    },
    connectionOpened({ commit }) {
      commit('SET_CONNECTION', true);
    },
    connectionClosed({ commit }) {
      commit('SET_CONNECTION', false);
    },
    connectionError({ commit }, error) {
      commit('SET_ERROR', error);
    },
    setMedicoFilters({ commit }, filtros) {
      commit('setMedicoFilters', filtros)
    },
    setFechaFilters({ commit }, filtros) {
      commit('setFechaFilters', filtros)
    },
    reservarTurno({ commit }, turno) {
      commit('reservarTurno', turno)
    },
    anularTurno({ commit }, turno) {
      commit('anularTurno', turno)
    },
    setMisTurnos({ commit }, listaTurnos) {
      commit('setMisTurnos', listaTurnos)
    },
    setOperacionFlag({ commit }, terminarOperacion) {
      commit('setOperacionFlag', terminarOperacion)
    },
    clearListaMisTurnos({ commit }) {
      commit('clearMisTurnos')
    },
    stopWebsocket({ commit }) {
      commit('STOP_CONNECTION')
    },
    async restartWebsocket({ dispatch }) {
      await dispatch('session/startConnection', null, { root: true })
    }
  }
}
